export const DyLangCn = {
    dashbordDy: {
        smsStats:'短信用量统计',
        totalsendnum:'发送总量',
        selfsendnum:'本人发送量',
        contactsendnum:'联系人发送量',
        nochoosed:'未选择',
        firstLoan:'首贷',
        CompoundLoan:'复贷',

        passAutomatically:'是否自动通过',
        yes:"是",
        no:'否',
        open:'打开',
        isOpen:'是否打开工单',
        ConfirmApplyForInterestFreeze: "确认要申请冻息吗？",
        StatusOfApplyForInterestFreeze: "申请冻息状态：",
        unknownFreezeStatus: "未知",
        numbersofperpage: '每页条数',
        oldnewtickets: '新老工单',
        newtickets: '新工单',
        oldtickets: '旧工单',
        canApplyForInterestFreeze: '可申请冻息',
        interestFreezeing: '冻息中',
        cannotApplyForInterestFreeze: '不可申请冻息',
        CardIssuanceFeeReduction:"减免开卡费",
        IsCardIssuanceFeeReduction: "是否减免开卡费？",
        notickets:'您已没有待处理工单，请提醒管理者分单',
        originalOrderNumber:'原始订单号',
        Repayment:'还款渠道',
        RelatedInformation:'关联信息',
        auditFailed:'审核未通过',
        examinationPassed:"审核通过",
        Unreviewed:'未审核',
        GenerateTicket:'生成工单',
        DialTheRecordingID:'拨打录音ID',
        Collector:'催收员',
        QualityInspector:"质检员",
        assigntime:'工单分配时间',
        startime:'工单开始时间',
        completetime:'工单完成时间',
        normal:'正常',
        AbusiveCustomer:'辱骂客户',
        sop:'不符合SOP',
        CustomerPromises:"顾客承诺与催记不一致",
        CollectionInformation:'催收信息',
        QualityInspectionInformation:'质检信息',
        Aging:'账龄',
        HangUpReason:'挂机原因',
        DialTime:'拨打时间',
        recording:'录音',
        RecordingType:'录音类型',
        processResult:'处理结果',
        NextCallTime:'下次拨打时间',
        NthLawyerLetter:'第N封律师函',
        sendingMethod:'发送方式',
        unassign:'确定取消分配？',
        queryConditions:'请至少一条填写查询信息',
        characters:'The label cannot exceed 80 characters',
        ticketID:'质检工单ID',
        source:"来源",
        RepaymentCode:'还款码',
        RepaymentCodeChannel:'还款码渠道',
        selectRepaymentCodeChannel:'请先选择还款码渠道',
        Date:'日期',
        CaseLevel:'工单分类',
        Totalorders:'工单总量',
        NoWhatAppsnumber:'无WhatsApp',
        HandleNumber:'催记数',
        HandleNumberpercent:'催记数百分比',
        TotalUnconnected:"Total Unconnected",	//总未接通
        Busy:"繁忙",
        Reject:	"拒听",
        NotActive:	"关机",
        CustomerBlocked	:"客户屏蔽"	,
        ContinueRinging:"无人接听",	
        OutofCoverage:"不在服务区",	
        NotRegisterd:"空号",
        TotalConnected:	"Total Connected",//总接通
        NoMoney:	"没有钱"	,
        LeftMessagetoCP:'要求CP传达',
        WTP:'有还款意愿',
        PartialPayment:	'部分还款',
        Rolling	:'展期',
        BP:	"不守诺言",
        Underestimate:	'歧视',
        DelayPayment:'还款暂缓'	,
        DataInvalid:'信息有误'	,	
        NotCustomer:'不是客户本人',
        DidReceiveMoney:'	客户未收到款项'	,
        Unconnected	:'未接通',
        Connected:'接通',																		 										
        Serialnumber:'序号',
        Employeeid:'员工id',
        Timeoff:'请假时间',
        Operatorid:"操作人id",
        Operatingtime:'操作时间',
        AM:'上午',
        PM:'下午',
        Cansetoff:'已请假',
        Noleave:'已销假',
        Leaveoff:'销假',
        Pleaseentervaliddays:'请输入有效天数',
        processingCompleted:'处理完成',
        confirmed:'已确定',
        SampleAnomaly:"样本异常",
        nexttikct:"下一单",
        Currentlythelastorder:'当前为最后一单',
        handle:"处理",
        UnmarkedContent:"无标注内容",
        recordingDuration:"录音时长",
        MachineQuality:"机器质检状态",
        QualityEnspection:"质检工单状态",
        CollectionVoice:'催收语音',
        salesman:"业务员",
        user:"用户",
        FinalQualityinspectionscore:"最终质检得分",
        AIQualityInspectionScore:"AI质检得分",
        ManualQualityInspectionScore: "人工质检得分",
        triggerFragment:"触发片段",
        triggerRule:"触发规则",
        ruleId:"规则id",
        QualityInspectionType:"质检类型",
        keywordsPhrases:"话术点/句",
        Score:"得分",
        AIQualityInspectionConfiguration:"AI质检配置",
        keywordLibrary:'关键词库',
        QualityInspectionRules:'质检规则',
        QCtext:'质检文本',
        QualityInspectionTemplate:"质检模板",
        newTalkPoint:"新建话术点",
        founder:'创建人',
        TalkPointName:"话术点库名称",
        Talkingpointlibrary:'话术点库',
        NumberOfSpeakingPoints:"话术点数量",
        RuleID:"规则ID",
        ruleName:"规则名称",   
        AddPoints:'加分',
        MinusPoints:'扣分',
        Scoring:'评分方式',
        score:'评分',
        TheNumberOfQualityInspectionPoints:'质检点个数',
        BasicInformation:"基本信息",
        RulesDescription:"规则说明",
        numberofmatches:"匹配次数",
        QualityInspectionPoints:"质检点",
        QCPointType:"质检点类型",
        QCobject:'质检对象',
        SpellPointHitRules:"话术点命中规则",
        Within:"连续",
        consecutiveReplies:"次回复内",
        Repeat :'重复',
        times:'次',
        AddQCpoint:"添加质检点",
        Thelogical:"各质检点间的逻辑关系",
        or:"或",
        and:'与',
        templateName:'模板名称',
        enabledstate:'启用状态',
        Scopeofapplication:'适用范围',
        Containstherulebook:'包含规则数',
        Inclusionrules:'包含规则',
        currentstate:'当前状态',
        Disable:'停用',
        addNewRules:'新建规则',
        TemplateDescription:'模板说明',
        Applicableaccountperiod:'适用账期',
        Qualityinspectionscoringitems:'质检评分项',
        Addaratingitem:'添加评分项',
        artificial:'人工',
        abandoned:'废弃',
        Obsolete:'已废弃',
        Copywriting:'文案纠错',
        Qualityinspectionlabel:'质检标注',
        correctcopywriting:'正确文案',
        speechrecognitioncopywriting:'语音识别文案',
        voiceclip:'语音片段',
        return:"返回",
        fix:"修正",
        Nocorrectionrequired:"无须修正",
        AIqualityinspectionstatus:"AI质检状态",
        Manualqualityinspectionscore:"人工质检得分",
        AIqualityinspectionscore:"AI质检得分",
        WaktupemeriksaankualitasAI:"AI质检时间",
        Notinspected:'未质检',
        Qualityinspected:"已质检",
        created:"已创建",
        unlimited:'不限',
        activated:"已启用",
        terminated:'已停用',
        finalscore:"最终得分",
        scoreisrepeated:'质检评分项重复，请核实后重新提交',
        previouspage:'您编辑的内容尚未保存提交，是否确认放弃编辑返回上一页？',
        continueediting:'继续编辑',
        confirmreturn:'确认返回',
        SpeechRecognitionCopywritinga:'语音识别文案纠错',
        UpdateAIscore:"更新AI评分",
        resultsafterwhile:'已经开始更新AI评分，请稍后再来查看结果。',
        Enterkeywordstofilter:'输入关键字进行过滤',
        totalorder:"合并订单",
        Rolloverorder:'被展期订单',
        Suborder:'子订单',
        GetQRcode:'获取二维码',
        QRcodebelow:'请手机登录WhatsApp，并扫描如下二维码登录WhatsApp',
        WhatsAppaccount:'请输入登录WhatsApp账号的手机信息:',
        manual: '手动',
        automatic: '自动',
        import:'导入',
        assignEmployeeId:'分配员工id',
        assignStatus:'分配状态',
        BatchImport:'批量导入',
        separated :'请输入国家编码+手机号\n号码之间以,分隔\n如86130xxxx1234,86130xxxx5678',
        inputMessage: '输入消息',
        callout:'标注',
        Unmark:'取消标注',
        HandlingAdvice:'处理建议',		
        callLabel:'通话标签'	,
        Isitarobot:"是否机器人催收",
        Robotlabel:"机器人通话标签",
        nolabel:'无标签'	,		
        IntentAnnotation:"意图标注",
        modifyIntent:"修改意图",
        UserIntent:'用户意图（单选）',
        repaymenttime:'还款时间',
        RepaymentAmount:'还款金额',
        RepaymentWay:'还款方式',
        AppName:'项目名称',
        selectAppName:'请先选择所属项目',
        subItem: '是否分项目',
        
Promisedrepaymentamount:'承诺还款金额',
Dialogueerrorcorrection:"对话纠错",
Modifyerrorcorrection:"修改纠错",
        notWAUser: '对方不是WhatsApp用户',
        notLoginWA: '当前账号没有登录WhatsApp',
        alreadyLoginWA: '您已经登录WhatsApp',
        pleaseSelectChat: '请选择一个聊天',
        emptyMessage: '聊天消息不能为空',
        noTemplateMessage: '不支持自定义消息',
hitstatement:"命中语句",
Identifycause:"识别错误原因",
    },

    
};
